<template>
  <div style="height:100%">
    <component :is="item.xtype" :key="index" :params="item"
               v-for='(item,index) in data'>
    </component>
  </div>
</template>

<script>
    export default {
        props:{
          data:Array
        },
        name: "layout-renderer"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/components/extend/layout/layout-renderer.vue